
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[locale]/legal",
      function () {
        return require("private-next-pages/[locale]/legal/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[locale]/legal"])
      });
    }
  